/**
 * Enum describing the origin of the drag action
 */
export enum DragStartPosition {
  BOTTOM,
  TOP,
}



// WEBPACK FOOTER //
// ./src/enums/DragStartPosition.ts